module.exports = " <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"card float-e-margins\"> <div class=card-content> <div class=row> <h1 class=text-center>Betaling geannuleerd!</h1> <h2 class=\"text-center text-danger\"><i class=\"fa fa-frown-o fa-5x\" aria-hidden=true></i></h2> <h4 class=text-center> U heeft de betaling geannuleerd! </h4> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/afterordening/betaling-geannuleerd.vue
// module id = 649
// module chunks = 0